<script setup>
import ApiService from "@/services/ApiService";

const props = defineProps({
  category: {
    type: String,
    default: null,
  },
  isLoading: Boolean,
});


const isGamesLoading = ref(true);
const games = ref([]);

async function loadGames() {

  try {
    let url = '/api/casino-games?limit=12';
    if (props.category !== null) {
      url += `&casino_game_category_ids[]=${props.category}`;
    }
    url += '&order=clicks';
    
    ApiService.get(url)
      .then((res) => {
        games.value = res.data;
        isGamesLoading.value = false;
      })
      .catch((error) => {
        games.value = [];
        isGamesLoading.value = false;
      })
      .finally(() => {
        isGamesLoading.value = false;
      });

  } catch (error) {
    console.error("Error loading games:", error);
  }

}

onBeforeMount(() => {
  loadGames();
  });

</script>

<template>
  <GameCarousel
    :is-loading="isLoading || isGamesLoading"
    title="Jogos Relacionados"
    :games="games.data"
  />
</template>
